import _ from 'lodash-es';
import {Injectable} from '@angular/core';
import {MediaService} from '@app/components/_common/medias/media.service';
import {ProjectsService} from '@app/services/projects.service';
import {
  AddMedia,
  AddMediaSuccess,
  DeleteMedia,
  DeleteMediaFailure,
  DeleteMediaSuccess,
  GetRecentProjectsList,
  GetRecentProjectsListFailure,
  GetRecentProjectsListSuccess,
  ProjectsActionTypes,
  RefreshMediasGallery,
  RefreshMediasGalleryFailure,
  RefreshMediasGallerySuccess, RefreshMediasGallerySuccessNoLoad,
  RefreshProjectsList,
  RefreshProjectsListFailure,
  RefreshProjectsListSuccess,
  RefreshSurveysList,
  RefreshSurveysListFailure,
  RefreshSurveysListSuccess,
} from '@app/store/actions/projects.actions';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {ChangeCurrentProjectId} from '@store/actions/auth.actions';
import {AppState} from '@store/app.states';
import {getUserAndProjectContext} from '@store/selectors/auth.selector';
import {getCommunitiesListStatus, getMediaUploadContext} from '@store/selectors/project.selector';
import {EMPTY, of} from 'rxjs';
import {catchError, map, switchMap, tap, withLatestFrom} from 'rxjs/operators';

import {AuthService} from '@app/services/auth/auth.service';
import {Project} from '@models/project.model';
// import {CommunitiesService} from '../../../@shared/inbe-communities-selector/communities.service';

@Injectable()
export class ProjectEffects {
  constructor(
    private actions: Actions,
    private store: Store<AppState>,
    private projectsService: ProjectsService,
    private mediaService: MediaService,
    // private communityService: CommunitiesService,
    private auth: AuthService,
  ) {
  }


  refreshProjectsList = createEffect(() => this.actions.pipe(
    ofType(ProjectsActionTypes.RefreshProjectsList),
    map((action: RefreshProjectsList) => action.payload),
    withLatestFrom(this.store.select(getUserAndProjectContext)),
    map((state) => state),
    switchMap(([payload, state]) => {

      // console.log('*** Project refresh effect');

      if (state.projectState.projectsList.length > 0 && !payload.forceRefresh) {
        return of(
          new RefreshProjectsListSuccess({
            projectList: state.projectState.projectsList,
          })
        );
      } else {
        if (!state.projectState.uxInteractions.recentProjectsList.loading) {
          return this.projectsService.getProjectList().pipe(
            map(
              (data) => {
                return new RefreshProjectsListSuccess({
                  projectList: data.data.projectList,
                });
              }
            ),
            catchError((error) => of(new RefreshProjectsListFailure({error})))
          );
        }
      }
      // }
    })
  ));


  GetRecentProjectsList = createEffect(() => this.actions.pipe(
    ofType(ProjectsActionTypes.GetRecentProjectsList),
    map((action: GetRecentProjectsList) => action.payload),
    withLatestFrom(this.store.select(getUserAndProjectContext)),
    map((state) => state),
    switchMap(([payload, state]) => {

      if (
        state.projectState.recentProjectsList.length > 0 &&
        !payload.forceRefresh
      ) {

        return of(
          new GetRecentProjectsListSuccess({
            list: state.projectState.recentProjectsList,
          })
        );
      } else {
        return this.projectsService.getRecentProjectList(payload.limit).pipe(
          map(
            (data) =>
              new GetRecentProjectsListSuccess({list: data.data.datas.rows})
          ),
          catchError((error) => of(new GetRecentProjectsListFailure({error})))
        );
      }
      // }
    })
  ));


  refreshProjectsListSuccess = createEffect(() => this.actions.pipe(
    ofType(ProjectsActionTypes.RefreshProjectsListSuccess),
    map((action: RefreshProjectsListSuccess) => action.payload),
    withLatestFrom(this.store.select(getUserAndProjectContext)),
    map((state) => state),
    tap(([payload, state]) => {
      // Si on a pas de currentProjectId : on va prendre le premier dans la liste !
      if (!state.authState?.user?.context?.currentProjectId) {
        // console.log(state.projectState.projectsList);
        this.store.dispatch(
          new ChangeCurrentProjectId({
            project: {
              id: state.projectState.projectsList[0].id,
              title: state.projectState.projectsList[0].title,
            },
            organization: {
              id: state.projectState.projectsList[0].organizationId,
              name: state.projectState.projectsList[0].organizationName,
            },
          })
        );
      }

      return EMPTY;
    })
  ), {dispatch: false});

  //
  //
  //
  refreshSurveysList$ = createEffect(() =>
    this.actions.pipe(
      ofType(ProjectsActionTypes.RefreshSurveysList),
      map((action: RefreshSurveysList) => action.payload),

      withLatestFrom(this.store.select(getUserAndProjectContext)),
      map((state) => state),

      switchMap(([payload, state]) => {
        if (!state.authState?.user?.context?.currentProjectId) {
          // // console.log(
          //   'On sait pas le projet current encore....',
          //   state.projectState.projectsList
          // );
          return EMPTY;
        } else {
          const cProjectIndex = state.projectState.projectsList.findIndex(
            (project) => {
              return (
                project.id === +state.authState.user.context.currentProjectId
              );
            }
          );

          let hasSurveys = false;
          if (cProjectIndex) {
            // console.log(state.projectState.projectsList[cProjectIndex]);
            if (state.projectState.projectsList[cProjectIndex]) {
              hasSurveys =
                Boolean(
                  state.projectState.projectsList[cProjectIndex].surveys
                ) &&
                state.projectState.projectsList[cProjectIndex].surveys.length >
                0;
            } else {
              hasSurveys = false;
            }
          }

          if (hasSurveys && !Boolean(payload.forceRefresh)) {
            return of(
              new RefreshSurveysListSuccess({
                projectId: +state.authState.user.context.currentProjectId,
                surveyList:
                state.projectState.projectsList[cProjectIndex].surveys,
              })
            );
          } else {
            return this.projectsService.getSurveyList(payload.projectId).pipe(
              map(
                (resp) =>
                  new RefreshSurveysListSuccess({
                    projectId: resp.data.projectId,
                    surveyList: resp.data.surveyList,
                  })
              ),
              catchError((error) =>
                of(new RefreshSurveysListFailure({error}))
              )
            );
          }
        }
      })
    )
  );

  // refreshMediaGallery$ = createEffect(() => this.actions.pipe(

  navigateToDashboard$ = createEffect(() => this.actions.pipe(
    ofType(ProjectsActionTypes.RefreshMediasGallery),
    map((action: RefreshMediasGallery) => action.payload),
    withLatestFrom(this.store.select((state) => state.projects)),
    switchMap(([payload, projects]) => {

      //
      // Si pas de project ID on met un 'neutre' ?
      //
      let projectId = payload?.projectId;
      if (!projectId && this.auth.getContext().type === 'annotator') {
        projectId = 5;
      }

      //
      // Est-ce qu'on a pas un projectId de pré-selectionné ?
      //
      if (projects.uxInteractions?.mediaGallery?.projectId) {
        projectId = projects.uxInteractions?.mediaGallery?.projectId;
      }

      //
      // Est-ce qu'on a déjà les médias pour ça ?
      //
      if (!payload?.forceRefresh) {
        // console.log('On a des medias ?', projectId, projects.projectsList);
        const project: Project = projects.projectsList.find((aProject) => aProject.id === projectId);
        // const project: Project = _.filter(projects.projectsList, {id: _.toInteger(projectId)})[0];
        // console.log(project);
        if (project?.medias?.length > 0) {
          // if (projects.projectsList[projectId]?.medias?.length > 0) {
          // return new RefreshMediasGallerySuccessNoLoad();
          return of(new RefreshMediasGallerySuccessNoLoad());
        }
      }

      return this.projectsService.getMediasList(projectId).pipe(
        map((data) => new RefreshMediasGallerySuccess({data})),
        catchError((error) => of(new RefreshMediasGalleryFailure({error})))
      );

      // } else {
      //  alert('Refresh survey List first ... Use Service :)');
      // }

    })
  ));
  // ));

  addMedia$ = createEffect(() =>
    this.actions.pipe(
      ofType(ProjectsActionTypes.AddMedia),
      map((action: AddMedia) => action.payload),
      withLatestFrom(this.store.select(getMediaUploadContext)),
      map((state) => state),
      switchMap(([payload, state]) => {

        // console.log('add media to project:', state.projectId);

        //
        // Si pas de project ID on met un 'neutre' ?
        //
        let projectId = payload?.projectId;
        if (!projectId && this.auth.getContext().type === 'annotator') {
          projectId = 5;
        }

        //
        // Est-ce qu'on a pas un projectId de pré-selectionné ?
        //
        if (state?.projectId) {
          projectId = state.projectId;
        }

        // alert('upload for project' + projectId);

        if (!projectId) {
          return of(new DeleteMediaFailure({error: 'Project ID is NULL!!!!!'}));
        }

        return this.mediaService
          .addMedia(
            projectId,
            payload.assembly,
            payload.fileScope)
          .pipe(
            map(
              (data) =>
                new AddMediaSuccess({
                  projectId: data.data.projectId,
                  medias: data.data.medias,
                })
            ),
            catchError((error) => of(new DeleteMediaFailure({error})))
          );
      })
    )
  );

  deleteMedia$ = createEffect(() =>
    this.actions.pipe(
      ofType(ProjectsActionTypes.DeleteMedia),
      map((action: DeleteMedia) => action.payload),
      switchMap((payload) => {
        return this.mediaService
          .deleteMedia(payload.projectId, payload.mediaId)
          .pipe(
            map(
              (data) =>
                new DeleteMediaSuccess({
                  projectId: data.data.projectId,
                  mediaId: data.data.mediaId,
                })
            ),
            catchError((error) => of(new DeleteMediaFailure({error})))
          );
      })
    )
  );


  //
  // Deprecated!!!!
  //

  // refreshList = createEffect(() => this.actions.pipe(
  //   ofType(ProjectsActionTypes.GetCommunityList),
  //   map((action: GetCommunityList) => action.payload),
  //   withLatestFrom(this.store.select(getCommunitiesListStatus)),
  //   map((state) => state),
  //   switchMap(([payload, state]) => {
  //
  //     // console.log(state);
  //
  //     if (state.communitiesList.length > 0 && !payload.forceRefresh) {
  //       // ? mmmm... non.
  //       // this.communityService.setCommunitiesListDirect(state.communitiesList as ICommunity[]);
  //       return of(new GetCommunityListSuccess({list: state}));
  //     } else {
  //
  //       // if (!state.isLoaded || payload.forceRefresh) {
  //
  //       return this.projectsService.getCommunitiesList().pipe(
  //         map(
  //           (data) => {
  //
  //             // console.log('Set Communities:', data.data.communities);
  //             this.communityService.setCommunitiesListDirect(data.data.communities);
  //
  //             //
  //             // A voir a virer pour libérer un peu de place ;)
  //             //
  //             return new GetCommunityListSuccess({list: data.data.communities});
  //           }
  //         ),
  //         catchError((error) => of(new GetCommunityListFailure({error})))
  //       );
  //
  //       // } else {
  //       //
  //       //   return EMPTY;
  //       //
  //       // }
  //
  //     }
  //   })
  // ));
}
